import { TemplatePage } from './types';

const collagePage: TemplatePage = {
  header: {
    color: '#F99DB6',
    icon: 'images/video-templates/trending-collage.jpg',
    title: 'Collage Video Templates Collection',
    title_meta: '50+ Free Customizable Collage Video Templates',
    description_meta:
      'Create beautiful video collages in a matter of minutes using Wave.video’s collection of 50+ customizable collage templates.',
    description:
      'Take your video content to the next level with this impressive collection of 50+ collage video templates. No design ' +
      'skills needed! Combine multiple visuals together with ease and create eye-catching comparison and reaction videos, product ' +
      'portfolios, video catalogs, or ads.'
  },
  footer: {
    category: 'Collage',
    description:
      'With the help of Wave.video’s wide range of customizable collage video templates, you can create stunning videos for ' +
      'your social media, blog, website, or email newsletter in a matter of minutes. All the templates are easy and free to ' +
      'personalize to suit your brand and message.'
  },
  content: [
    {
      type: 'templates',
      title: 'Collage Video Templates',
      search: { name: 'collage' }
    },
    {
      type: 'stocks',
      title: 'collage',
      search: { name: 'collage' }
    },
    { type: 'calendar' }
  ]
};

export default collagePage;
